import messageListPC from './MessageListPC.vue';

export default messageListPC;
